"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DigitalePräsenz() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2425" id="digitale-präsenz-neu-definiert" className="relative w-full bg-background text-foreground overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[92vh] lg:h-[92vh]">
        {}
        <div ref={imageRef} className={`relative w-full lg:w-[55%] h-[60vh] lg:h-full overflow-hidden transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="relative w-full h-full lg:rounded-r-none rounded-b-lg lg:rounded-bl-lg lg:rounded-tl-lg overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/webdesign_agency_oldenburg.png" alt="Webdesign-Service für Unternehmen von Orvo Web" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

            {}
            <div className="absolute inset-0 pointer-events-none" style={{
            background: "linear-gradient(115deg, hsla(0, 0%, 4%, 0.35) 0%, hsla(0, 0%, 4%, 0.1) 45%, hsla(43, 50%, 55%, 0.18) 100%)"
          }} />

            {}
            <div className="absolute top-0 right-0 h-full w-1/3 pointer-events-none" style={{
            background: "linear-gradient(270deg, hsla(43, 50%, 55%, 0.45) 0%, hsla(43, 50%, 55%, 0.12) 50%, transparent 100%)",
            mixBlendMode: "screen"
          }} />

            {}
            <div className="absolute inset-0 pointer-events-none opacity-[0.12] mix-blend-overlay" style={{
            backgroundImage: "radial-gradient(hsla(43, 20%, 90%, 0.6) 1px, transparent 1px)",
            backgroundSize: "3px 3px"
          }} />

            {}
            <div className="absolute bottom-6 left-6 lg:bottom-8 lg:left-8 z-10">
              <p className="font-mono text-[11px] lg:text-xs tracking-[0.22em] uppercase" style={{
              color: "hsl(43 50% 94%)"
            }}>
                Oldenburg · 53.1435° N, 8.2147° E
              </p>
            </div>
          </div>
        </div>

        {}
        <div aria-hidden="true" className="hidden lg:block absolute top-0 bottom-0 left-[55%] w-px" style={{
        background: "hsla(43, 20%, 25%, 0.25)"
      }} />

        {}
        <div className="relative w-full lg:w-[45%] flex items-center bg-background">
          <div ref={textRef} className={`w-full px-6 sm:px-10 lg:px-24 py-16 lg:py-0 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <p className="font-mono text-xs tracking-[0.32em] uppercase mb-8 lg:mb-12 text-primary">
              Orvo Web · Digitales Handwerk
            </p>

            {}
            <h1 className="font-default font-light text-foreground leading-[0.95] text-[3.5rem] sm:text-[4.5rem] lg:text-[6rem] xl:text-[7rem] tracking-tight">
              <span className="block">Webdesign, das aus</span>
              <span className="block italic font-light" style={{
              color: "hsla(43, 50%, 55%, 0.85)"
            }}>
                Besuchern Kunden macht.
              </span>
            </h1>

            {}
            <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground/70 mt-8 lg:mt-10 max-w-md">
              Für wen Orvo Web arbeitet: Handwerker, Restaurants, lokale Dienstleister, kleine Unternehmen, Selbstständige. Welches Problem wird gelöst: mehr Vertrauen, besser gefunden werden, mehr Anfragen.
            </p>

            {}
            <p className="font-default text-lg lg:text-xl text-muted-foreground mt-4 lg:mt-6 max-w-md leading-relaxed">
              Eine Website soll nicht nur gut aussehen. Sie soll Vertrauen aufbauen, Besucher führen und aus Interesse echte Anfragen machen. Orvo Web entwickelt moderne Websites für Unternehmen, die online professioneller auftreten und mehr Kunden gewinnen möchten.
            </p>

            {}
            <div className="mt-10 lg:mt-12 flex flex-wrap items-center gap-6 lg:gap-8">
              <Button asChild size="lg" className="rounded-lg px-8 h-12 font-mono text-xs tracking-[0.2em] uppercase bg-primary text-primary-foreground hover:bg-primary/90 shadow-md">
                <Link to="/ContactPage">Jetzt anfragen</Link>
              </Button>

              <Link to="/ServicesPage" className="font-default text-base text-foreground underline underline-offset-8 decoration-1 hover:decoration-2 transition-all inline-flex items-center gap-2 group">
                Webdesign-Services
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>

              <Link to="/ServicesPage" className="font-default text-base text-foreground underline underline-offset-8 decoration-1 hover:decoration-2 transition-all inline-flex items-center gap-2 group">
                Unsere Leistungen
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>

            {}
            <div className="hidden lg:flex absolute bottom-10 right-10 flex-col items-end gap-2">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase" style={{
              color: "hsla(43, 20%, 45%, 0.5)"
            }}>
                § 01
              </span>
              <div className="w-px h-10" style={{
              background: "hsla(43, 50%, 55%, 0.35)"
            }} />
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase" style={{
              color: "hsla(43, 20%, 45%, 0.5)"
            }}>
                Strategie
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}